import { fetchAuthSession } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";

import useDeflowSessionStore, {
  DeflowSessionStates,
} from "@/stores/useDeflowSessionStore";
import { configureAmplifyForActiveCell } from "@/lib/cell";

let listenersStarted = false;

function sessionTokensFromAmplify(session: Awaited<
  ReturnType<typeof fetchAuthSession>
>) {
  const t = session.tokens;
  if (!t?.accessToken || !t?.idToken) return undefined;
  const rt = (t as unknown as { refreshToken?: { toString(): string } })
    .refreshToken;
  return {
    accessToken: t.accessToken.toString(),
    idToken: t.idToken.toString(),
    refreshToken: rt ? rt.toString() : "",
  };
}

export async function hydrateDeflowSession() {
  configureAmplifyForActiveCell();
  try {
    const session = await fetchAuthSession();
    const tokens = sessionTokensFromAmplify(session);
    if (!tokens) {
      useDeflowSessionStore.getState().setNotAuthenticated();
      return;
    }
    useDeflowSessionStore.getState().setAuthenticated({
      lastSignIn: Date.now(),
      tokens,
    });
  } catch {
    useDeflowSessionStore.getState().setNotAuthenticated();
  }
}

export function bootstrapBrowserAuth() {
  configureAmplifyForActiveCell();
  if (typeof window === "undefined") return;
  if (!listenersStarted) {
    listenersStarted = true;
    Hub.listen("auth", async ({ payload }) => {
      switch (payload.event) {
        case "signedIn":
        case "tokenRefresh": {
          await hydrateDeflowSession();
          break;
        }
        case "signedOut":
        case "signInWithRedirect_failure": {
          useDeflowSessionStore.getState().setNotAuthenticated();
          break;
        }
        default:
          break;
      }
    });
  }
  void hydrateDeflowSession();
}

export function isAuthenticatedFromStore() {
  const { sessionState, tokens } = useDeflowSessionStore.getState();
  return (
    sessionState === DeflowSessionStates.Authenticated &&
    !!tokens?.accessToken
  );
}
